import { lazy } from 'lib/retry';

const TextDocument = lazy(async () => import('./index'));

export default TextDocument;
